<script setup lang="ts">
import TurnosMarcaje from "./components/TurnosMarcaje.vue";
import TurnosListado from "./components/TurnosListado.vue";
import { isAdmin } from "../../utils/permisos";
</script>

<template>
  <div class="space-y-6">
    <TurnosMarcaje />
    <TurnosListado v-if="isAdmin()" />
  </div>
</template>
